import { Color, ShaderMaterial, DoubleSide } from 'three';
import vertexShader from './aurora.vert.glsl';
import fragmentShader from './aurora.frag.glsl';

export interface AuroraShaderUniforms {
    time: { value: number };
    bottomColor: { value: Color };
    middleColor: { value: Color };
    topColor: { value: Color };
    auroraColor1: { value: Color };
    auroraColor2: { value: Color };
    auroraColor3: { value: Color };
    auroraIntensity: { value: number };
    glowIntensity: { value: number };
}

export class AuroraShaderMaterial extends ShaderMaterial {
    public constructor() {
        const uniforms: AuroraShaderUniforms = {
            time: { value: 0 },
            bottomColor: { value: new Color('#3f1680') },
            middleColor: { value: new Color('#293d9f') },
            topColor: { value: new Color('#e6e5e5') },
            auroraColor1: { value: new Color('#00dbe6') },
            auroraColor2: { value: new Color('#9b03ba') },
            auroraColor3: { value: new Color('#b295df') },
            auroraIntensity: { value: 1},
            glowIntensity: { value: 0.4 },
        };

        super({
            //@ts-ignore
            uniforms,
            vertexShader,
            fragmentShader,
            side: DoubleSide,
        });
    }

    public updateTime(time: number) {
        this.uniforms.time.value = time;
    }

    public setColors(colors: Partial<Record<keyof AuroraShaderUniforms, Color>>) {
        Object.entries(colors).forEach(([key, color]) => {
            if (this.uniforms[key] && color instanceof Color) {
                this.uniforms[key].value = color;
            }
        });
    }
}